<template>
    <div>
        <div v-if="client">
            <p class="title is-5">Rules content</p>
            <!-- bottom content rules -->
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Bottom content</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <content-string-ref v-if="client.settings.bonusSettings.bottomContentRules"
                                :content-ref="client.settings.bonusSettings.bottomContentRules"
                                :delete-func="() => client.settings.bonusSettings.bottomContentRules = null" />
                            <content-string-selector v-else
                                :clientId="clientId"
                                :add-func="(contentRef) => client.settings.bonusSettings.bottomContentRules = contentRef" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- save -->
            <div class="field is-horizontal">
                <div class="field-label"></div>
                <div class="field-body">
                    <div class="field is-grouped">
                        <div class="control">
                            <button @click="save" class="button is-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';
import ContentStringSelector from '../../../../common/content/string/content-string-selector.vue';

export default {
    name: 'client-settings-bonus-rules-content',
    components: { ContentStringRef, ContentStringSelector },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        },
        deleteContentRef(contentRefArray, index) {
            contentRefArray.splice(index, 1);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/bonuses/rules-content.vue